﻿'use strict';

angular.module('ntmApp')
  .filter('positiveNegativeNumberFormat', function () {

      return function (input) {

          if (angular.isNumber(input)) {

              var number = parseInt(input);
              return number > 0 ? "+" + number : input;
          }

          return input;
      };
  });